import { useState } from 'react';

import { useCreateFolderMutation } from 'components/hooks/folderMutations';
import useForm from 'components/hooks/useForm';

import { defaultFolder } from 'components/projectsDashboard/helpers/index';

export default function useProjectRelocationModal() {
  const createFolderMutation = useCreateFolderMutation();

  const [currentFolder, setCurrentFolder, handleCurrentFolderInputChange] =
    useForm(defaultFolder);

  const [selectedDestinationFolderId, setSelectedDestinationFolderId] =
    useState(null);

  const isFolderNameInUseTheOnlyCreateFolderError =
    createFolderMutation.isError &&
    createFolderMutation.error.response.status === 422 &&
    createFolderMutation.error.response.data.errors.length === 1 &&
    createFolderMutation.error.response.data.errors[0].detail ===
      'Name already in use';

  const creationBlockingExistingFolder =
    isFolderNameInUseTheOnlyCreateFolderError ?
      createFolderMutation.error.response.data.meta.existingFolder.data
    : null;

  const handleDestinationFolderSelect = (id) => {
    setSelectedDestinationFolderId(id);
  };

  const handleReset = () => {
    createFolderMutation.reset();
    setCurrentFolder(defaultFolder);
    setSelectedDestinationFolderId(null);
  };

  return {
    createFolderMutation,
    creationBlockingExistingFolder,
    currentFolder,
    handleCurrentFolderInputChange,
    handleDestinationFolderSelect,
    handleReset,
    selectedDestinationFolderId,
  };
}
